/**
 * @generated SignedSource<<21d916d7a0d3dd31d154021647072958>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "request"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "request",
        "variableName": "request"
      }
    ],
    "concreteType": "Page_Pool",
    "kind": "LinkedField",
    "name": "poolsByViewer",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Pool",
        "kind": "LinkedField",
        "name": "content",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cardPan",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "cardType",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "recToken",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "confirmPaymentComponentsPoolsByViewerQuery",
    "selections": (v1/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "confirmPaymentComponentsPoolsByViewerQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "41ea317d9b20080f3f1f8aca5800a531",
    "id": null,
    "metadata": {},
    "name": "confirmPaymentComponentsPoolsByViewerQuery",
    "operationKind": "query",
    "text": "query confirmPaymentComponentsPoolsByViewerQuery(\n  $request: PoolsRequestInput\n) {\n  poolsByViewer(request: $request) {\n    content {\n      id\n      cardPan\n      cardType\n      recToken\n    }\n  }\n}\n"
  }
};
})();

node.hash = "fbae85d0594ee8cb1fbad8aa95915346";

module.exports = node;
